import { AuthLevel, generateApiPath } from '@guiker/shared-framework'

export const paths = {
  payInMethod: generateApiPath({ prefix: AuthLevel.AUTH, name: 'payment-method' }),
}
